import script from "./CreateDespatch.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateDespatch.vue?vue&type=script&setup=true&lang=js"

import "./CreateDespatch.vue?vue&type=style&index=0&id=296d8d1c&lang=css"

const __exports__ = script;

export default __exports__